import { db } from '~/plugins/firebase'
import { doc, collection } from 'firebase/firestore'

export const generateUid = () => {
  return doc(collection(db, 'random')).id
}
